import React from 'react'

import { IconButton, Typography } from '@material-ui/core'
import { ReactComponent as EditOutline } from '../../../assets/EditOutline.svg'

// Заметка (до 60 символов) показывается целиком и переносится по словам,
// слово без пробелов рвётся где придётся (business_apps#1472). Карандаш
// склеен с последней буквой, чтобы не остаться на строке один.
export default function thirdPartyEditIcon({
  alias,
  onClick,
  t,
  iconButtomStyle,
  iconStyle,
  ...props
}) {
  // по символам, а не UTF-16: эмодзи в конце не разрежется пополам
  const chars = Array.from(alias || t('common:field.note'))
  return (
    <IconButton
      size="small"
      style={{
        ...{
          display: 'flex',
          alignItems: 'center',
          flex: '0 1 auto',
          minWidth: 0,
          maxWidth: '100%',
        },
        ...iconButtomStyle,
      }}
      onClick={onClick}
    >
      <Typography
        style={{ minWidth: 0, textAlign: 'left', overflowWrap: 'anywhere' }}
      >
        ({chars.slice(0, -1).join('')}
        <span style={{ whiteSpace: 'nowrap' }}>
          {chars.slice(-1).join('')})
          <EditOutline
            style={{
              ...{ width: 20, height: 20, verticalAlign: 'text-bottom' },
              ...iconStyle,
            }}
          />
        </span>
      </Typography>
    </IconButton>
  )
}
